module.exports = __webpack_public_path__ + "static/media/liked.a608c317.svg";